import * as React from "react";
import {Component} from "react";
import {observer} from "mobx-react";
import {DashboardSolution} from "data/entities/DashboardSolution";
import {computed} from "mobx";
import {BadgeGroup, generateBadgeGroups} from "components/badges/BadgeGroup";
import {CardButton} from "components/dashboard/CardButton";
import {UIState} from "data/UIState";
import {PageEnums} from "components/nav/PageEnums";
import {BadgeCount} from "components/badges/BadgeCount";

import './DashboardBadgeBlock.pcss';
import {BadgeCard} from "components/badges/BadgeCard";
import {IBadgeGroup} from "shared/IBadgeGroup";

interface Props {
  badgedDashboardSolutions:DashboardSolution[]
}

@observer
export class DashboardBadgeBlock extends  Component<Props> {

  @computed get groupedBadges() {
      return generateBadgeGroups(this.props.badgedDashboardSolutions);
  }

render() {

  if(UIState.settings.HIDE_BADGE_COMPONENT || 0===this.groupedBadges.length) {
    return null;
  }

  const latestGroup = this.groupedBadges[0];
  function findLastScoringGroup(groupedBadges:BadgeGroup[]) {
    if(groupedBadges.length>1) {
      for(let i=1;i<groupedBadges.length;i++) {
        if(groupedBadges[i].badges>0) {
          return groupedBadges[i];
        }
      }
    }
    return null;
  }
  const lastScoringGroup = findLastScoringGroup(this.groupedBadges); // this.groupedBadges.length>1 ? : null;
  const showHistory = (this.props.badgedDashboardSolutions.length - latestGroup.badges > 0) || latestGroup.badges>1

  return (
    <>
      <h2 className={'level2'}>Badges Earned</h2>

      <div className={"dashboard-badge-block"}>
        <div>
          <div>

            <h3 className={'level3 shadow'}>{latestGroup.name}&nbsp;&bull;&nbsp;{0 === latestGroup.badges ? <span style={{fontWeight:'normal'}}>you haven’t earned a badge yet</span> : <>{latestGroup.badges} badge{latestGroup.badges !== 1 ? 's' : ''} earned</>}</h3>

            {latestGroup.desc && <p>{latestGroup.desc}</p>}


            {0===latestGroup.badges && <div className={'dbb-no-badges'}>Badges will show here</div>}

            {1===latestGroup.badges && <BadgeCard key={latestGroup.badgedDashboardSolutions[0]._id} solution={latestGroup.badgedDashboardSolutions[0]} />}

            {1<latestGroup.badges &&
              <div className={'dbb-badges'}>
                {latestGroup.badgeCounts.map((c,idx) => <BadgeCount key={c.badgeType.id+"_"+idx} badgeCount={c}/>)}
              </div>
            }

            {lastScoringGroup && <p className={"ps"}>In {lastScoringGroup.name} you earned {lastScoringGroup.badges} badge{lastScoringGroup.badges !== 1 ? 's' : ''}</p>}

          </div>

          {showHistory &&
            <CardButton buttonAction={() => {UIState.currentPage = PageEnums.badgeHistory; }} buttonLabel={'Badge Gallery'}/>
          }

        </div>
      </div>


  </>
  );
  }
}


/*


    <div className={"badged-solutions"}>
          <ul className={"reset"} >
            {this.props.badgedDashboardSolutions.map((dashboardSolution, idx) => {
              const liClassName = idx>0 && (idx+1)%3==0 ? 'end' : '';
              return (
                <li key={dashboardSolution._id} className={liClassName}>
                  <BadgeCard
                    badge={dashboardSolution.badge}
                    solutionName={dashboardSolution.name}
                    solutionTotalPoints={dashboardSolution.points}
                    whenAchieved={dashboardSolution.badgeEarnedDate}
                  />
                </li>
              );
            })}
          </ul>
        </div>
 */
